var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5958 6.6967L17.3029 7.4038L7.4034 17.3033L6.69629 16.5962L16.5958 6.6967Z",
    fill: "#2B303B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69718 7.40385L7.40429 6.69674L17.3038 16.5962L16.5967 17.3033L6.69718 7.40385Z",
    fill: "#2B303B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.244268f0143b03c7ca08d9d1074f9029.svg";
export { ForwardRef as ReactComponent };